export default function InitialController($location, OauthService, $window, localStorageService, $scope, $rootScope, $state, IdentityMgmtService) {
  var self = this;
  
  let code = localStorageService.get('code');
  let currentUrl = $location.absUrl();
  if(!localStorageService.get('userlgd') && !code){
    $window.location.href = OauthService.redirectToGoogle();
  }
  else{
    if(!localStorageService.get('userlgd')){
      OauthService.getTokenFromGResp(code).then(function(resp){
        localStorageService.set('a_token', resp.data.access_token);
        OauthService.getUserInfo(resp.data.access_token).then(function(resp){
          $scope.$broadcast('userInfo', resp.data);
          localStorageService.set('userlgd', true);
          localStorageService.set('userInfo', resp.data);
          localStorageService.set('code', '');
        });
      });
    }
  }

  $scope.$on('$viewContentLoading', function(e) {
    if(localStorageService.get('userlgd')){

    }
    else{
      if($rootScope.unauthUser){
        //Goes to Unauth State.
      }
      else{
        $state.go('olr.mainfe.landing');
      }
    }
  });

  $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
    // Future Code to track the state change
  });

}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe/InitialController.js
 **/